import { routeNotVisitable } from "@/data/app-data";
import React from "react";
import { FiHome } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom"; // Import dari react-router-dom
import { mergeClass, seperateWordByHyphen } from "../../utils/helper";
import classes from "./BreadCrumb.module.css";
import { cn } from "@/utils/cn";

export const BreadCrumb = ({ separator, capitalizeLinks }) => {
  const location = useLocation();
  const paths = location.pathname;
  const pathNames = paths.split("/").filter(Boolean);

  const customLabels = {
    "fx-rates": "FX Rates",
    "currency-management": "Currency Management",
  };

  const normalizeKey = (key) => key.toLowerCase();

  return (
    <div className={classes.main}>
      <ul className={classes.container}>
        {/* Home Breadcrumb */}
        <li className={classes.list}>
          <Link to={"/dashboard"} className={classes.linkStyle}>
            <div
              className={cn(
                classes.flex,
                "hover:underline decoration-1 underline-offset-1"
              )}
            >
              <FiHome
                className={classes.icon}
                size={18}
                color="var(--green-v4)"
              />
              <p className="fw-300">Home (Dashboard)</p>
            </div>
          </Link>
        </li>

        {pathNames.length > 0 && (
          <span className={classes.separator}>{separator}</span>
        )}

        {/* Generate Breadcrumbs */}
        {pathNames.map((link, index) => {
          let href = `/${pathNames.slice(0, index + 1).join("/")}`;
          const isNotVisitable = routeNotVisitable.includes(href);

          let itemLink =
            customLabels[normalizeKey(link)] || seperateWordByHyphen(link);

          if (capitalizeLinks && !customLabels[normalizeKey(link)]) {
            itemLink = itemLink[0].toUpperCase() + itemLink.slice(1);
          }

          return (
            <React.Fragment key={index}>
              <li
                className={mergeClass(
                  "fw-300 hover:underline decoration-1 underline-offset-1",
                  classes.itemList
                )}
              >
                {isNotVisitable ? (
                  <span className={classes.nonClickable}>{itemLink}</span>
                ) : (
                  <Link to={href} className={classes.linkStyle}>
                    {itemLink}
                  </Link>
                )}
              </li>
              {pathNames.length !== index + 1 && (
                <span className={classes.separator}>{separator}</span>
              )}
            </React.Fragment>
          );
        })}
      </ul>
    </div>
  );
};
